import { Flex, Text, Input } from "@chakra-ui/react";

const TextInput = ({ label, errors, touched, ...props }) => {
  return (
    <>
      <Flex justifyContent="space-between" w="100%"
      flexDir={'column'}
      >
        <Text mr="20px" minW="80px">
          {label}
        </Text>
        <Input {...props} />
      </Flex>
      <Flex minH={
        errors && touched ? '40px' : '15px'
      } color={"red.500"}>
        {errors && touched && errors}
      </Flex>
    </>
  );
};

export default TextInput;
